import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { StoreService } from '../service/store-service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-store',
  templateUrl: './add-store.component.html',
  styleUrls: ['./add-store.component.css']
})
export class AddStoreComponent implements OnInit {

  storeForm!: FormGroup;
  storeTypes: any[] = [];   // dropdown data
  BusinessArea: any;
  isLoading: boolean;

  constructor(private fb: FormBuilder, private storeService: StoreService,) { }

  ngOnInit(): void {
    this.createForm();
    this.loadStoreTypes();
    this.loadBusinessUnit();

  }

  createForm() {
    this.storeForm = this.fb.group({
      Businessunit: [''],
      Storetype: [''],       // storeTypeId
      Skuname: [''],         // storeName
      Sdescription: [''],    // storeDescription
      Slocation: [''],       // storeLocation
      Bname: [''],           // buildingName
      Fname: [''],           // floorName
      sos: [''],             // sizeOfStore
      Cname: [''],           // contactName
      Cno: [''],             // contactNo
      email: ['']            // email
    });
  }
  loadBusinessUnit() {
    this.isLoading = true;
    this.storeService.getBusinessUnit().subscribe((res) => {
      this.BusinessArea = res;
      this.isLoading = false;

      // console.log(res);    
    });
  }
  loadStoreTypes() {
    const payload = {
      btn_name: "STORE_TYPE_VIEWALL",
      businessAreaId: Number(localStorage.getItem("businessAreaId"))
    };

    this.storeService.getAllStoreTypes(payload).subscribe((res: any) => {
      this.storeTypes = res;     // API response expected
      console.log("storeTypes>>>", this.storeTypes)
    });
  }

  onSubmit() {
    if (this.storeForm.invalid) return;

    const form = this.storeForm.value;
    this.isLoading = true;

    const payload = {
      btn_name: "STORE_ADD",
      storeName: form.Skuname,
      storeTypeId: form.Storetype,
      storeDescription: form.Sdescription,
      storeLocation: form.Slocation,
      buldingName: form.Bname,
      floorName: form.Fname,
      sizeOfStore: form.sos,
      contactName: form.Cname,
      contactNo: form.Cno,
      email: form.email,
      businessAreaId: localStorage.getItem("businessAreaId"),
      createdBy: localStorage.getItem("userId")
    };
    // const payload = {
    //   "btn_name": "STORE_ADD", "storeName": "Main Warehouse", "storeTypeId": 2, "storeDescription": "Medicine central storage", "storeLocation": "Building A", "buldingName": "Block 5", "floorName": "1st Floor", "sizeOfStore": "3500 Sqft", "contactName": "Ramesh Kumar", "contactNo": "9876543210", "email": "store@mail.com", "businessAreaId": 1, "createdBy": 101
    // }

    console.log("Final Payload:", payload);

    this.storeService.addStore(payload).subscribe((response: any) => {
      console.log("Store Saved Successfully:", response);
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Data saved successfully.',
        confirmButtonColor: '#3085d6'
      });
     this.isLoading = false;
      this.onReset();
    });
  }

  onReset() {
    this.storeForm.reset({
      Businessunit: ''
    });
  }

  goBack() {
    history.back();
  }
}
